import {LoginRequestService} from '../services/login-request.service';
import {FlowContextStore} from '../stores';
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthStore } from '../stores';

/**
 * Interceptor para manejo centralizado de errores HTTP
 */
export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const authStore = inject(AuthStore);
  const loginRequest = inject(LoginRequestService);
  const flow = inject(FlowContextStore);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let errorMessage = 'Ha ocurrido un error';

      if (error.error instanceof ErrorEvent) {
        // Error del lado del cliente
        errorMessage = `Error: ${error.error.message}`;
      } else {
        // Error del lado del servidor
        const serverMessage = typeof error.error === 'string'
          ? error.error
          : error.error?.message || error.error?.detail;
        switch (error.status) {
          case 401:
            errorMessage = req.url.endsWith('/auth/customer-login') ? (serverMessage || 'Email o contraseña incorrectos.') : 'Tu sesión ha caducado. Inicia sesión nuevamente.';
            if (!req.url.endsWith('/auth/customer-login')) {
              authStore.clear();
              if (!/^\/(login|register)([?/#]|$)/.test(router.url)) loginRequest.request(router.url, {companyId:flow.companyId() || 1});
            }
            break;
          case 403:
            errorMessage = 'No tienes permisos para realizar esta acción.';
            break;
          case 404:
            errorMessage = 'Recurso no encontrado.';
            break;
          case 500:
            errorMessage = 'Error del servidor. Intenta de nuevo más tarde.';
            break;
          default:
            errorMessage = serverMessage || `Error: ${error.status}`;
        }
      }

      if (error.error?.code === 'VALIDATION_ERROR') {
        const fields = Object.keys(error.error.details || {});
        const socialRequest = req.url.endsWith('/api/customers/sso-login');
        if (socialRequest) {
          errorMessage = fields.includes('email')
            ? 'La cuenta seleccionada no ha facilitado un correo válido. Prueba con otra cuenta o accede con email.'
            : fields.includes('firebaseToken') || fields.includes('firebaseUid') || fields.includes('provider')
              ? 'No se pudo validar el acceso con esa cuenta. Vuelve a seleccionarla e inténtalo de nuevo.'
              : 'No se pudo completar el acceso con esa cuenta. Prueba de nuevo o accede con email.';
        } else {
          const details = Object.values(error.error.details || {}).filter((value): value is string => typeof value === 'string');
          if (details.length) errorMessage = details.join(' ');
        }
      }
      console.error('HTTP Error:', errorMessage, error);
      return throwError(() => ({ ...error, message: errorMessage }));
    })
  );
};
